import { put, select, takeEvery, call } from 'redux-saga/effects';
import size from 'lodash/size';

import chatConsts from '../constants';
import { lastSocialIdSelector } from '../../board/selectors/settings';
import { currentLocationSelector } from '../../common/selectors';
import { showSocialChatSelectionAlert } from './social-chat-selection-saga';
import {
  defaultFirstActiveChannel,
  channelsListSelector,
} from '../../board/selectors/channels';
import { MESSAGES } from '../../../constants/routes';

function* socialChannelSelectionWorker() {
  const location = yield select(currentLocationSelector);
  const channelsList = yield select(channelsListSelector);
  const lastSocialId = yield select(lastSocialIdSelector);
  const firstChannelId = yield select(defaultFirstActiveChannel);
  const isMessagingPage = location.includes(MESSAGES);

  if (isMessagingPage && size(channelsList) > 0) {
    yield put({
      type: chatConsts.SET_ACTIVE_CHANNEL_ID,
      payload: lastSocialId || firstChannelId,
    });

    yield call(showSocialChatSelectionAlert);
  }
}

export default function* socialChannelSelectionSaga() {
  yield takeEvery(
    [chatConsts.SOCIAL_CHAT_INIT_SELECTION],
    socialChannelSelectionWorker,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/social-сhat-init-selection-saga.js